<template>
  <div class="edit-rate-table">
    <loading :isShow="pageLoading" />
    <Form ref="form" :model="formData" class="page-form" label-position="left">
      <div class="date-wrap">
        <FormItem prop="versionStartTime" label="生效时间" :rules="editType == 1 ? dateRule : dateRule2">
          <DatePicker
            type="date"
            format="yyyy-MM-dd"
            :options="optionsStartDay"
            v-model="sDate"
            :clearable="false"
            placeholder="选择日期"
            style="width: 150px"
            @on-change="changeDate('start')"
          ></DatePicker>
          <TimePicker
            type="time"
            placeholder="选择时间"
            style="width: 150px"
            :value="sTime"
            format="HH:mm:ss"
            @on-change="
              sTime = $event;
              changeDate('start');
            "
            :clearable="false"
          ></TimePicker>
        </FormItem>
        <FormItem prop="versionEndTime" label="失效时间" :rules="dateRule1">
          <DatePicker
            type="date"
            format="yyyy-MM-dd"
            :options="optionsStopMonth"
            v-model="eDate"
            :clearable="false"
            placeholder="选择日期"
            style="width: 150px"
            @on-change="changeDate('end')"
          ></DatePicker>
          <TimePicker
            type="time"
            placeholder="选择时间"
            style="width: 150px"
            :value="eTime"
            format="HH:mm:ss"
            @on-change="
              eTime = $event;
              changeDate('end');
            "
            :clearable="false"
          ></TimePicker>
        </FormItem>
        <div class="btn-wrap">
          <Button type="primary" ghost @click="$emit('cancel')" style="margin-right: 10px">取消</Button>
          <Button type="primary" @click="save">保存</Button>
        </div>
      </div>
      <Button type="primary" class="btn-left" @click="copyProgram(999)" style="margin-right: 10px">新增一行</Button>
      <div class="table" id="tableBox">
        <div class="table-wrap">
          <div class="head-wrap" id="headWrap">
            <div
              v-for="(item, index) in columns"
              :key="index"
              class="head"
              :style="
                item.width ? 'width:' + item.width + 'px;flex:0 0 ' + item.width + 'px;' : '' + item.minWidth ? 'min-width:' + item.minWidth + 'px;flex:1;' : ''
              "
              :class="{
                'sort': item.type == 'index',
                'tools-wrap': item.key == 'commission' && item.totalCommission == item.commissionIndex,
                'right': item.fixed == 'right',
                'left': item.fixed == 'left',
                'left-1': item.slot == 'gradeCode',
                'left-2': item.slot == 'programId'
              }"
            >
              <span v-if="item.title">{{ item.title }}</span>
              <span v-if="item.key == 'commission' && item.totalCommission == item.commissionIndex && formData.tableData.length">
                <i
                  v-if="item.commissionIndex != 1 && !single"
                  class="ivu-icon ivu-icon-md-close-circle"
                  @click="
                    delYear({
                      commissionIndex: item.commissionIndex
                    })
                  "
                ></i>
                <i
                  v-if="!single"
                  class="ivu-icon ivu-icon-md-add-circle"
                  @click="
                    addYear({
                      commissionIndex: item.commissionIndex + 1
                    })
                  "
                ></i>
                <Checkbox
                  v-if="item.commissionIndex > 5"
                  v-model="single"
                  @on-change="$event => setFullYear({ untilLast: $event, commissionIndex: item.commissionIndex })"
                  >至交费期满</Checkbox
                >
              </span>
            </div>
          </div>
          <div v-if="formData.tableData.length" class="content-wrap" id="contentBody">
            <div
              v-for="(item, index) in formData.tableData"
              :key="item.programId + index"
              :id="'a' + formData.productCode + item.gradeCode"
              class="content-limit"
            >
              <div
                class="box"
                v-for="(column, idx) in columns"
                :key="idx"
                :style="
                  column.width
                    ? 'width:' + column.width + 'px;flex:0 0 ' + column.width + 'px;'
                    : '' + column.minWidth
                    ? 'min-width:' + column.minWidth + 'px;flex:1;'
                    : ''
                "
                :class="{
                  'sort': column.type == 'index',
                  'tools-wrap': column.key == 'commission' && column.totalCommission == column.commissionIndex,
                  'right': column.fixed == 'right',
                  'left': column.fixed == 'left',
                  'left-1': column.slot == 'gradeCode',
                  'left-2': column.slot == 'programId'
                }"
              >
                <template v-if="column.type == 'index'">{{ index + 1 }}</template>
                <template v-else-if="column.slot == 'gradeCode'">
                  <Form-item :prop="'tableData.' + index + '.gradeCode'" :rules="{ required: true, message: '请选择险种', trigger: 'change' }">
                    <Select
                      v-model="formData.tableData[index].gradeCode"
                      @on-change="changeProduct($event, index)"
                      placement="bottom"
                      :transfer="true"
                      filterable
                      placeholder="请选择"
                    >
                      <Option v-for="(item, i) in productAdditions" :key="i" :value="item.gradeCode">{{ item.name }}</Option>
                    </Select></Form-item
                  >
                </template>
                <template v-else-if="column.slot == 'programId'">
                  <Form-item
                    :prop="`tableData.${index}.programId`"
                    :key="`tableData.${index}.programId`"
                    :rules="{ required: true, message: ' ', trigger: 'change' }"
                  >
                    <editRateSelect v-model="formData.tableData[index].programId" @change="change($event, index)" :list="programBases" />
                  </Form-item>
                </template>
                <template v-else-if="column.slot == 'action'">
                  <span class="table-btn" @click="copyProgram(index)">复制</span>
                  <span class="table-btn" @click="delProgram(index)">删除</span>
                </template>
                <template v-else-if="column.key != 'commission' && column.key">
                  {{ formData.tableData[index] | getFactor(column) }}
                </template>
                <template v-else-if="column.key == 'commission'">
                  <InputNumber :min="0" :max="100" v-model="formData.tableData[index].innerCommissions[column.commissionIndex - 1].value" />
                </template>
                <template v-else>{{ formData.tableData[index][column.key] }}</template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Form>
    <!-- 确认弹窗 -->
    <confirm-modal ref="confirmModal"></confirm-modal>
  </div>
</template>

<script>
var editType;
import dayjs from 'dayjs';
import filter from '@/api/filter';
import { config } from './editRateTable.config.js';
import confirmModal from '@/components/commons/confirmModal';
import editRateSelect from './editRateSelect';
export default {
  mixins: [config],
  components: {
    editRateSelect,
    confirmModal
  },
  props: ['productAdditions', 'programBases', 'templateId'],
  data() {
    return {
      dateRule: {
        required: true,
        trigger: 'change',
        validator(rule, value, callback) {
          if (!value) {
            callback(new Error('请选择生效时间'));
          } else if (dayjs(value).format('YYYY-MM-DD HH:mm:ss') > dayjs().format('YYYY-MM-DD HH:mm:ss')) {
            callback(new Error('生效时间只可以选当前时间之前的时间'));
          } else {
            callback();
          }
        }
      },
      dateRule1: {
        required: true,
        trigger: 'change',
        validator: (rule, value, callback) => {
          if (!value) {
            callback(new Error('请选择失效时间'));
          } else if (dayjs(value).format('YYYY-MM-DD HH:mm:ss') < dayjs().format('YYYY-MM-DD HH:mm:ss')) {
            callback(new Error('失效时间只可以选当前时间之后的时间'));
          } else {
            callback();
          }
        }
      },
      dateRule2: {
        required: true,
        trigger: 'change',
        validator(rule, value, callback) {
          if (!value) {
            callback(new Error('请选择生效时间'));
          } else if (dayjs(value).format('YYYY-MM-DD HH:mm:ss') < dayjs().format('YYYY-MM-DD HH:mm:ss')) {
            callback(new Error('生效时间只可以选当前时间之后的时间'));
          } else {
            callback();
          }
        }
      },
      filter,
      optionsStartDay: {
        disabledDate: date => {
          if (this.editType == 2 || this.editType == 3) {
            return date && dayjs().isAfter(dayjs(date)) && dayjs().format('YYYY-MM-DD') != dayjs(date).format('YYYY-MM-DD');
          } else {
            return date && date.valueOf() > Date.now();
          }
        }
      },
      optionsStopMonth: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      show: false,
      single: false,
      pageLoading: false,
      columns: [],
      code: '',
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      sDate: '',
      eDate: '',
      sTime: '',
      eTime: '',
      formData: {
        productId: '',
        productCode: '',
        tableData: [],
        versionEndTime: '',
        versionStartTime: ''
      },
      editType: '1',
      allProgramFactors: [],
      innerCommissionsColumns: []
    };
  },
  filters: {
    getFactor(val, item) {
      return val.factors.find(i => i.roleCode == item.key) ? val.factors.find(i => i.roleCode == item.key).remark : '-';
    }
  },
  watch: {},
  created() {
    this.getAllProgramFactors();
  },
  methods: {
    saveCurrentVersion() {
      let url = '';
      let params = {
        versionStartTime: filter.filterTime(this.formData.versionStartTime, 'YYYY-MM-DD HH:mm:ss'),
        versionEndTime: filter.filterTime(this.formData.versionEndTime, 'YYYY-MM-DD HH:mm:ss'),
        productCode: this.formData.productCode,
        tenantId: this.userInfo.tenantId
      };
      if (this.editType == '1' && !this.formData.versionNo) {
        url = '/buz/commission/version/add';
        params.untilLastCommissionIndex = this.single ? 1 : 0;
      } else if (this.editType == '1' && this.formData.versionNo) {
        url = '/buz/commission/version/edit';
        params.versionNo = this.formData.versionNo;
        params.id = this.formData.id;
      } else if (this.editType == '2' && this.formData.versionNo) {
        url = '/buz/commission/version/editFuture';
        params.versionNo = this.formData.versionNo;
        params.id = this.formData.id;
      } else if (this.editType == '3') {
        url = '/buz/commission/version/addFuture';
        params.untilLastCommissionIndex = this.single ? 1 : 0;
      }
      return new Promise((resolve, reject) => {
        this.$http({
          url,
          type: 'POST',
          data: params
        })
          .then(res => {
            if (this.editType == 3) {
              this.formData.copyVersionNo = this.formData.versionNo;
              this.editType = 2;
            } else {
              this.formData.copyVersionNo = undefined;
            }
            if (res.data && res.data.versionNo) {
              this.formData.versionNo = res.data.versionNo;
            }
            resolve(res.data);
          })
          .catch(() => {
            reject();
            // this.single =!this.single;
          });
      });
    },
    /**
     * flag Boolean 费率为0保存时，是否提示
     * saveType String //save 保存期数 add 新增期数  del删除期数  setFull 至交费期满
     */
    async save(flag = false, saveType = 'save') {
      return new Promise((resolve, reject) => {
        if (this.pageLoading) return;
        this.$refs.form.validate().then(async isok => {
          let isProgramNotice = false;
          this.formData.tableData.forEach(item => {
            if (!item.programId) {
              isProgramNotice = true;
            }
          });
          if (isProgramNotice) {
            reject();
            return this.$notice.error(`请选择方案!`);
          }

          if (!isok) {
            reject();
            return;
          }
          if (!this.formData.versionStartTime) {
            reject();
            return this.$notice.error('请选择生效时间');
          }
          if (!this.formData.versionEndTime) {
            reject();
            return this.$notice.error('请选择失效时间');
          }
          if (
            filter.filterTime(this.formData.versionStartTime, 'YYYY-MM-DD HH:mm:ss') == filter.filterTime(this.formData.versionEndTime, 'YYYY-MM-DD HH:mm:ss')
          ) {
            reject();
            return this.$notice.error('生效时间与失效时间不能一致');
          }
          if (
            filter.filterTime(this.formData.versionStartTime, 'YYYY-MM-DD HH:mm:ss') > filter.filterTime(this.formData.versionEndTime, 'YYYY-MM-DD HH:mm:ss')
          ) {
            reject();
            return this.$notice.error('失效时间不能早于生效时间');
          }
          if (dayjs(this.formData.versionEndTime).diff(this.formData.versionStartTime, 'day') < 2) {
            reject();
            return this.$notice.error('生效时间和失效时间需至少间隔48小时');
          }
          if (flag) {
            let isNotice = true;
            this.formData.tableData.forEach(item => {
              if (item.innerCommissions.some(i => i.value != 0)) {
                isNotice = false;
              }
            });
            if (isNotice && this.formData.tableData.length > 0) {
              let token = '1';
              if (saveType == 'save') {
                await this.$notice.inquiry(`费用未填写。如下级已有此产品，下级费率也为0！请确认是否保存？`);
              } else {
                try {
                  await this.$notice.inquiry(`修改期数将自动保存。检测到当前费率未填写，如下级已有此产品，下级费率也为0！请确认是否保存？`);
                } catch (e) {
                  token = null;
                }
              }
              if (!token) {
                reject();
                return;
              }
            }
          }
          let version = null;
          try {
            version = await this.saveCurrentVersion();
          } catch (error) {
            version = null;
          }
          console.log('this.formData', this.formData);
          if (!version) {
            reject();
            return;
          }
          this.pageLoading = true;
          this.$http({
            url: '/buz/commission/sys/modifyAndGradeProgram',
            type: 'POST',
            data: {
              versionNo: this.formData.versionNo,
              productId: this.formData.productId,
              productCode: this.formData.productCode,
              commissionList: this.formData.tableData.map((item, idx) => {
                if (item.innerCommissions) {
                  item.innerCommissions = item.innerCommissions.map(i => {
                    if (!i.value) i.value = 0;
                    i.parentValue = i.value;
                    return i;
                  });
                }
                item.orderNum = idx + 1;
                return item;
              }),
              templateId: this.templateId,
              copyVersionNo: this.formData.copyVersionNo
            }
          })
            .then(async res => {
              resolve('');
              this.pageLoading = false;
              if (flag && saveType == 'save') {
                this.$Message.success('操作成功');
                this.$emit('success', version ? version : {});
              }
            })
            .catch(() => {
              this.pageLoading = false;
            });
        });
      });
    },
    changeInput(event, index, column) {
      this.formData.tableData[index].innerCommissions[column.commissionIndex - 1].value = event;
    },
    // 切换时间
    changeDate(type) {
      if (type == 'start') {
        if (!this.sDate) {
          return;
        }
        const date = filter.filterTime(this.sDate, 'YYYY-MM-DD');
        if (!this.sTime) {
          this.sTime = '00:00:00';
        }
        this.formData.versionStartTime = new Date(date + ' ' + this.sTime);
      } else {
        if (!this.eDate) {
          return;
        }
        const date = filter.filterTime(this.eDate, 'YYYY-MM-DD');
        if (!this.eTime) {
          this.eTime = '23:59:59';
        }
        this.formData.versionEndTime = new Date(date + ' ' + this.eTime);
      }
    },
    //删除方案
    delProgram(index) {
      this.formData.tableData.splice(index, 1);
    },
    //复制
    copyProgram(index) {
      if (index == 999) {
        //新增一行
        let data = {};
        if (this.formData.tableData && this.formData.tableData.length) {
          data = JSON.parse(JSON.stringify(this.formData.tableData[0]));
        }
        data.factors = [];
        data.isMain = true;
        data.programId = '';
        data.gradeCode = '00';
        if (data.innerCommissions && data.innerCommissions.length) {
          data.innerCommissions = data.innerCommissions.map((i, idx) => {
            i.parentValue = 0;
            i.value = 0;
            i.id = '';
            i.commissionIndex = idx + 1;
            return i;
          });
        } else {
          data.innerCommissions = [];
          for (let index = 0; index < this.formData.commissionNum; index++) {
            data.innerCommissions[index] = {
              parentValue: 0,
              value: 0,
              id: '',
              commissionIndex: index + 1
            };
          }
        }
        this.formData.tableData = JSON.parse(JSON.stringify([...this.formData.tableData, data]));
      } else {
        //复制
        this.formData.tableData = JSON.parse(JSON.stringify([...this.formData.tableData, this.formData.tableData[index]]));
      }
      this.scrollTo(2);
    },
    changeProduct($event, index) {
      let product = this.productAdditions.find(i => i.gradeCode == $event);
      this.formData.tableData[index].isMain = product.isMain == '1';
    },
    change(data, index) {
      this.$http({
        url: '/buz/commission/program/queryProgramFactor',
        type: 'POST',
        data: {
          programId: data.value
        }
      }).then(res => {
        this.formData.tableData[index].factors = res.data;
        // this.formData = JSON.parse(JSON.stringify(this.formData));
        this.$set(this.formData, 'tableData', this.formData.tableData);
        let isSame = res.data.every(item => {
          return this.columns.find(i => i.key == item.roleCode);
        });
        if (isSame) return;
        let arr = [];
        this.formData.tableData.forEach(item => {
          arr.push(...item.factors);
        });
        this.getProgramIdColumns(arr);
      });
    },
    getProgramIdColumns(arr, type = null) {
      let columns = [];
      if (this.formData.tableData.length == 1 && this.productInfo.isEdit && !this.formData.tableData[0].programId) {
        if (this.productInfo.productCategory == '3') {
          columns = [
            {
              title: '交费期',
              key: 'payment',
              align: 'center',
              minWidth: 150,
              render(h, params) {
                return <span>{params.row.payment ? params.row.payment : '-'}</span>;
              }
            }
          ];
        }
      } else {
        arr.forEach(factorItem => {
          if (columns.findIndex(column => column.key == factorItem.roleCode) == -1) {
            let factor = this.allProgramFactors.find(item => item.code == factorItem.roleCode);
            if (factor.code != 'LK000011' || this.productInfo.productCategory == '3') {
              columns.push({
                title: factor.name,
                key: factorItem.roleCode,
                align: 'center',
                render: (h, params) => {
                  let factor = params.row.factors.find(i => i.roleCode == params.column.key);
                  return <span>{factor ? factor.remark || '-' : '-'}</span>;
                },
                minWidth: 150
              });
            }
          }
        });
      }
      this.columns = [
        {
          title: '序号',
          type: 'index',
          align: 'center',
          fixed: 'left',
          width: 80
        },
        {
          title: '险种名称',
          slot: 'gradeCode',
          align: 'center',
          minWidth: 260,
          fixed: 'left'
        },
        {
          title: '方案名称',
          slot: 'programId',
          align: 'center',
          minWidth: 260,
          fixed: 'left'
        },
        ...columns,
        ...this.innerCommissionsColumns,
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 130,
          fixed: 'right'
        }
      ];

      this.$nextTick(() => {
        const arr = document.getElementsByClassName('content-limit');
        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          if (document.getElementById(element.id.replace('a', 'b'))) {
            document.getElementById(element.id.replace('a', 'b')).style.height = element.clientHeight + 'px';
          }
        }
        document.getElementById('contentBody').style.width = document.getElementById('headWrap').scrollWidth + 'px';
      });
      if (type) {
        //表单滑动
        this.scrollTo(type);
      }
    },
    scrollTo(type = 1) {
      //type 1 滚动到最右边  2最底部
      window.setTimeout(() => {
        if (type == 1) {
          document.querySelectorAll('.table-wrap')[0].scrollLeft = document.querySelectorAll('.table-wrap')[0].scrollWidth;
        } else if (type == 2) {
          document.querySelectorAll('.table-wrap')[0].scrollTop = document.querySelectorAll('.table-wrap')[0].scrollHeight;
        }
      }, 300);
    },
    getAllProgramFactors() {
      this.$http({
        url: '/buz/programRule/getAllRule',
        type: 'GET',
        data: {}
      }).then(res => {
        this.allProgramFactors = res.data;
      });
    },

    // 删除交费年限
    async delYear(params) {
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '请确认是否删除？'
        })
        .then(async () => {
          if (!this.$units.pointAction('pro_7_1')) {
            this.$notice.error('无权操作，请联系您的上级');
            return;
          }
          await this.save(true, 'del');
          this.pageLoading = true;
          this.$http({
            url: '/buz/upcommission/delCommissionNum',
            type: 'POST',
            data: {
              versionNo: this.formData.versionNo,
              commissionIndex: params.commissionIndex,
              productCode: this.formData.productCode
            }
          })
            .then(res => {
              this.pageLoading = false;
              this.getDetail(1);
            })
            .catch(() => {
              this.pageLoading = false;
            });
        });
    },
    // 新增交费年限
    async addYear(params) {
      if (!this.$units.pointAction('pro_7_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      await this.save(true, 'add');
      this.pageLoading = true;
      this.$http({
        url: '/buz/upcommission/addCommissionNum',
        type: 'POST',
        data: {
          versionNo: this.formData.versionNo,
          commissionIndex: params.commissionIndex,
          productCode: this.formData.productCode,
          commissionList: this.formData.tableData.map(item => {
            return {
              isMain: item.isMain,
              gradeCode: item.gradeCode,
              programId: item.programId,
              commission: 0
            };
          })
        }
      })
        .then(res => {
          this.pageLoading = false;
          this.getDetail(1);
        })
        .catch(() => {
          this.pageLoading = false;
        });
    },
    // 设置至交费期满
    async setFullYear(params) {
      if (!this.$units.pointAction('pro_7_1')) {
        this.$nextTick(() => {
          this.single = !params.untilLast;
        });
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      let sign = '1';
      try {
        await this.save(true, 'setFull');
      } catch (error) {
        sign = null;
      }
      if (!sign) {
        this.$nextTick(() => {
          this.single = !params.untilLast;
        });
        return;
      }
      this.pageLoading = true;
      this.$http({
        url: params.untilLast ? '/buz/upcommission/setCommissionUntilLast' : '/buz/upcommission/cancelCommissionUntilLast',
        type: 'POST',
        data: {
          versionNo: this.formData.versionNo,
          commissionIndex: params.commissionIndex,
          productCode: this.formData.productCode
        }
      })
        .then(async res => {
          this.getDetail();
          this.pageLoading = false;
        })
        .catch(() => {
          this.pageLoading = false;
        });
    },
    // editType 1编辑或新增当前版本  2编辑未来版本   3复制当前版本新增未来版本
    //productInfo 存在versionNo 是编辑  不存在就是新增
    init(productInfo, editType = '1') {
      this.editType = editType;
      productInfo = JSON.parse(JSON.stringify(productInfo));
      if (editType == 3 && productInfo.versionEndTime) {
        // 复制版本生效时间处理
        const date = new Date(productInfo.versionEndTime);
        date.setSeconds(date.getSeconds() + 1);
        productInfo.versionStartTime = dayjs(date).format('YYYY-MM-DD HH:mm:ss');
        productInfo.versionEndTime = '';
      }
      if (productInfo.versionNo) {
        console.log('当前版本号', productInfo);
        this.formData.versionNo = productInfo.versionNo;
        this.formData.versionEndTime = productInfo.versionEndTime ? new Date(productInfo.versionEndTime) : '';
        this.formData.versionStartTime = productInfo.versionStartTime ? new Date(productInfo.versionStartTime) : '';
        this.formData.versionType = productInfo.versionType; // -1历史版本  0当前版本 1未来版本
        this.formData.id = productInfo.id;
      } else {
        this.formData.versionNo = '';
        this.$set(this.formData, 'versionEndTime', '');
        this.$set(this.formData, 'versionStartTime', '');
        this.formData.versionType = '';
        this.formData.id = '';
      }
      this.sDate = this.formData.versionStartTime;
      this.sTime = this.sDate ? dayjs(this.sDate).format('HH:mm:ss') : '';
      this.eDate = this.formData.versionEndTime;
      this.eTime = this.eDate ? dayjs(this.eDate).format('HH:mm:ss') : '';
      this.productInfo = productInfo;
      this.getDetail(null, productInfo.isEdit);
      //1-团险 2-财产险 3、个险
      if (this.productInfo.productCategory == '3') {
        this.columns = [
          {
            title: '序号',
            type: 'index',
            align: 'center',
            fixed: 'left',
            width: 80
          },
          {
            title: '险种名称',
            slot: 'gradeCode',
            align: 'center',
            width: 170,
            fixed: 'left'
          },
          {
            title: '方案名称',
            slot: 'programId',
            align: 'center',
            minWi: 170,
            fixed: 'left'
          }
        ];
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import './editRateTable.scss';

.btn-left {
  margin-bottom: 20px;
}
.edit-rate-table {
  position: relative;
  .ivu-form-item {
    margin-bottom: 0;
    margin: 0 10px;
    margin-right: 10px !important;
  }
  /deep/.ivu-input {
    margin: 0 10px;
    width: calc(100% - 20px);
  }
}
/deep/.f-c {
  display: flex;
  align-items: center;
}
.date-wrap {
  display: flex;
  margin-bottom: 20px;
  position: relative;
  .btn-wrap {
    position: absolute;
    right: 10px;
  }
  /deep/.ivu-form-item-label:before {
    content: '*';
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 14px;
    color: #ed4014;
  }

  /deep/.ivu-form-item-error-tip {
    left: 10px;
  }
}
/deep/.page-form .ivu-form-item {
  display: flex;
  width: 400px;
  .ivu-form-item-content {
    flex: 1;
  }
  .ivu-input-suffix {
    right: 10px;
    cursor: pointer;
  }
}
</style>
